import { HttpService } from './http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NGXLogger } from "ngx-logger";
import { configuration, extAccessLog, extAccessSearchModel } from 'src/app/archive-external-access/models';
import { keyValuePair, property } from 'src/app/models';
import { callbackDisplayConfigModel } from 'src/app/callback-display/models';

@Injectable({
  providedIn: 'root'
})

export class callbackDisplayService {


  constructor(private http: HttpService, private logger: NGXLogger) { }

  getCallbackDisplayConfigList(): Observable<property[]> {
    return this.http.getFromApi(`/CallbackDisplay/list`);
  }

  public getCallbackDisplayConfig(id: number): Observable<callbackDisplayConfigModel> {
    return this.http.getFromApi(`/CallbackDisplay/config/${id}`);
  }

  public saveCallbackDisplayConfig(config: callbackDisplayConfigModel, logo: File, picture: File): Observable<any> {
    const formData: FormData = new FormData();
    if (logo) {
      formData.append("logo", logo, logo.name);
    }
    if (picture) {
      formData.append("picture", picture, picture.name);
    }
    formData.append("model", JSON.stringify(config));
    return this.http.postFormDataToApi(`/CallbackDisplay/Config`, formData);
  }

  deleteCallbackDisplayConfig(id: number): Observable<callbackDisplayConfigModel> {
    return this.http.postToApi(`/CallbackDisplay/Delete/`, JSON.stringify(id));
  }

  getCallbackDisplayConfigLogo(id:number): Observable<Blob> {
    return this.http.getBlobFromApi(`/CallbackDisplay/Config/logo/${id}`);
  }

  getCallbackDisplayConfigPicture(id:number): Observable<Blob> {
    return this.http.getBlobFromApi(`/CallbackDisplay/Config/picture/${id}`);
  }

  getCallbackDisplayUsage(id:number): Observable<string[]> {
    return this.http.getFromApi(`/CallbackDisplay/checkUsage/${id}`);
  }
}
